import { render, staticRenderFns } from "./select-search.vue?vue&type=template&id=5049e28b&scoped=true"
import script from "./select-search.vue?vue&type=script&lang=js"
export * from "./select-search.vue?vue&type=script&lang=js"
import style0 from "./select-search.vue?vue&type=style&index=0&id=5049e28b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049e28b",
  null
  
)

export default component.exports